import { DropdownItem } from "@mcleod/components";
import { AutogenLayoutCarrierUnassignmentHistoryReport } from "./autogen/AutogenLayoutCarrierUnassignmentHistoryReport";

export class CarrierUnassignmentHistoryReport extends AutogenLayoutCarrierUnassignmentHistoryReport {
    override onLoad(): void | Promise<void> {
        this.textboxDateType.items = [
            new DropdownItem("S", "Ship Date(s)"),
            new DropdownItem("B", "Bill Date(s)"),
            new DropdownItem("D", "Delivery Date(s)")
        ];
        this.textboxSortBy.items = [
            new DropdownItem("B", "Unassigned Count"),
            new DropdownItem("C", "Carrier"),
            new DropdownItem("T", "Reaction Time")
        ];
        this.textboxGroupBy.items = [
            new DropdownItem("C", "Carrier"),
            new DropdownItem("U", "Dispatcher"),
            new DropdownItem("A", "Revenue Code"),
            new DropdownItem("R", "Customer"),
            new DropdownItem("E", "Reason Code")
        ];

        this.textboxDateType.selectedItem = this.textboxDateType.items[0]; // Ship Date(s)
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[0]; // Unassigned Count
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0]; // Carrier
    }
}
